import React, { useState, useContext, useEffect } from "react";
import Filter from "./Filter";
import StatusProjectCount from "./StatusProjectCount";
import AmountPendingAndAccepted from "./AmountPendingAndAccepted";
import FormsAnalysis from "./FormsAnalysis";
import { DataContext } from "../../../../context/dataprovider.js";
import styles from "./Transactions.module.css"; // Importing CSS module

const Transactions = () => {
  const { userData = {} } = useContext(DataContext);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [projectIds, setProjectIds] = useState([]);

  useEffect(() => {
    // Set default to all projectIds when userData loads
    if (userData?.projectId?.length) {
      setProjectIds(userData.projectId);
    }
  }, [userData]);

  const handleFilterApply = (from, to, selectedProjects) => {
    setFromDate(from);
    setToDate(to);
    if (selectedProjects?.length > 0) {
      setProjectIds(selectedProjects);
    } else {
      // If cleared, set to all
      setProjectIds(userData.projectId);
    }
  };

  return (
    <div className={styles.transactionsContainer}>
      <Filter
        onApply={handleFilterApply}
        availableProjects={userData.projectId || []}
        className={styles.filter}
      />
      <div className={styles.analysisContainer}>
        <StatusProjectCount
          fromDate={fromDate}
          toDate={toDate}
          projectId={projectIds}
          className={styles.card}
        />
        <AmountPendingAndAccepted
          fromDate={fromDate}
          toDate={toDate}
          projectId={projectIds}
          className={styles.card}
        />
        <FormsAnalysis
          fromDate={fromDate}
          toDate={toDate}
          projectId={projectIds}
          className={styles.card}
        />
      </div>
    </div>
  );
};

export default Transactions;
